export const projects = [
  {
    title: "YatraSetu – A Comprehensive Tourism Platform",
    description:
      "Developed a multi-faceted tourism and travel platform featuring role-based access for users, hotel managers, and admins. Includes hotel booking, route optimization, and a full management dashboard. Tech Stack: React.js, Java Spring Boot, with deployment via CI/CD.",
    languages: ["React.js", "Java Spring Boot", "CI/CD"],
    url: "https://yatrasetu.vercel.app",
    github_url: "https://github.com/Divyx09/YatraSetu",
    image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=600&auto=format&fit=crop&q=80",
    category: "Full-Stack",
  },
  {
    title: "AI-Powered Waste Management & Recycling Marketplace",
    description:
      "Built an AI-powered waste classification and trading platform using a CNN model and desktop app. Enabled buyer-seller marketplace with automated data sync and role-based access. Added predictive pricing to forecast trends and optimize selling decisions. Tech Stack: React.js, FastAPI, MongoDB, ML.",
    languages: ["React.js", "FastAPI", "MongoDB", "ML"],
    url: "https://github.com/Divyx09",
    image: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=600&auto=format&fit=crop&q=80",
    category: "AI / ML",
  },
  {
    title: "CraftAura.in - Artworks E-Commerce",
    description:
      "Built a live e-commerce platform for artwork shopping with user authentication, cart management, and admin dashboard. Tech Stack: React.js + Redux + Spring Boot + MongoDB/CI/CD. Features include secure payment processing, inventory management, and responsive design.",
    languages: ["React.js", "Redux", "Spring Boot", "MongoDB", "CI/CD"],
    url: "https://craftaura.in",
    github_url: "https://github.com/Divyx09/CraftAura-Frontend",
    backend_url: "https://github.com/Divyx09/CraftAura-Backend",
    image: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=600&auto=format&fit=crop&q=80",
    category: "E-Commerce",
  },
  {
    title: "TradeApp",
    description:
      "React Native trading app with multi-role panels: User, Broker, Super Admin. Integrated Node.js backend and Yahoo Finance APIs for real-time stock data and candlestick charts. Features secure authentication, portfolio tracking, and live market data.",
    languages: ["React Native", "Node.js", "Yahoo Finance API", "MongoDB"],
    url: "https://github.com/Divyx09/TradeApp",
    backend_url: "https://github.com/Divyx09/TradeApp-Backend",
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&auto=format&fit=crop&q=80",
    category: "Mobile App",
  },
  {
    title: "Lost & Found Portal",
    description:
      "React.js + Spring Boot web app enabling institutions to track lost/found items with secure user authentication and admin approval workflow. Features include item categorization, image upload, notification system, and comprehensive admin panel.",
    languages: ["React.js", "Spring Boot", "MySQL", "JWT Authentication"],
    url: "https://github.com/Divyx09/Lost-Found-Portal",
    backend_url: "https://github.com/Divyx09/Lost-Found-Backend",
    image: "https://images.unsplash.com/photo-1501250986500-ef91ae7f2881?w=600&auto=format&fit=crop&q=80",
    category: "Web App",
  },
  {
    title: "Phone-Shop",
    description:
      "An e-commerce website where users can browse and purchase phones. The frontend provides a user-friendly interface for selecting products, while the backend handles APIs for product management, user authentication, and order processing. The project ensures smooth integration between the frontend and backend for a seamless shopping experience.",
    languages: ["React.js", "Java Spring Boot", "CSS"],
    url: "https://github.com/Divyx09/Phone-Shop",
    backend_url: "https://github.com/Divyx09/Phone-Shop-backend-",
    image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=600&auto=format&fit=crop&q=80",
    category: "Full-Stack",
  },
  {
    title: "Pet-Connect",
    description:
      "A website where pets are diagnosed based on their symptoms, and proper medications are suggested. It provides a complete prescription for the pet and connects users with online pet doctors for consultations.",
    languages: ["React.js", "Java Spring Boot", "CSS"],
    url: "https://github.com/Divyx09/Pet-Connect",
    backend_url: "https://github.com/Divyx09/Pet-Connect-backend",
    image: "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=600&auto=format&fit=crop&q=80",
    category: "Web App",
  },
  {
    title: "Indimart_website",
    description:
      "This project represents my major accomplishment during my diploma program. It's a full-fledged shopping website built using Python's Django framework. The website caters to the needs of online shoppers, providing a user-friendly platform to browse and purchase products.",
    languages: ["HTML", "CSS", "Python (Django)"],
    url: "https://github.com/Divyx09/Indimart_website_1.0",
    image: "https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=600&auto=format&fit=crop&q=80",
    category: "Django Web",
  },
  {
    title: "BHARAT-News",
    description:
      "A simple news application that provides news updates based on the user's entered location. Built using React and styled with Bootstrap for a responsive design.",
    languages: ["React", "Bootstrap"],
    url: "https://github.com/Divyx09/BHARAT-News",
    image: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=600&auto=format&fit=crop&q=80",
    category: "React App",
  },
  {
    title: "Assitan_Bot-MAVERICK",
    description:
      "A voice-controlled assistant similar to JARVIS. It allows users to perform various tasks such as opening files, launching applications, performing calculations, conducting Google searches, and much more. Built entirely in Python using its libraries.",
    languages: ["Python"],
    url: "https://github.com/Divyx09/Assitan_Bot-MAVERICK",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&auto=format&fit=crop&q=80",
    category: "Python AI",
  },
  {
    title: "Divya Attarde Portfolio",
    description:
      "A personal portfolio website showcasing skills, projects, experiences, education, and contact information. It includes a 3D model of myself implemented using Three.js. The website integrates APIs developed in the backend to manage dynamic data. The backend is built using Java Spring Boot to create and serve APIs, while the frontend is built using React.js for a seamless user experience.",
    languages: ["React.js", "Three.js", "Java Spring Boot", "CSS"],
    frontend_url: "https://github.com/Divyx09/divya--attarde-portfolio",
    backend_url: "https://github.com/Divyx09/divya-portfolio-backend",
    image: "https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?w=600&auto=format&fit=crop&q=80",
    category: "Web Frontend",
  },
  {
    title: "Calculator",
    description:
      "A basic calculator application that performs arithmetic operations like addition, subtraction, multiplication, and division. Built using HTML, CSS, and JavaScript.",
    languages: ["HTML", "CSS", "JavaScript"],
    url: "https://github.com/Divyx09/Calculator",
    image: "https://images.unsplash.com/photo-1587141815725-186a59f8652b?w=600&auto=format&fit=crop&q=80",
    category: "Utility Tool",
  },
  {
    title: "D4Ulooger",
    description:
      "A blogging website created using HTML, CSS, and JavaScript where users can visit and write their reviews on various topics. A simple platform for sharing opinions and thoughts.",
    languages: ["HTML", "CSS", "JavaScript"],
    url: "https://github.com/Divyx09/D4Ulooger",
    image: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=600&auto=format&fit=crop&q=80",
    category: "Blog App",
  },
];
